import React from "react";
import { JSX } from "react/jsx-runtime";

const TickIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect width="26" height="26" rx="13" fill="#FCFCFF"/>
        <path d="M9.30052 12.2407C8.84561 11.5523 7.89457 11.3342 7.17631 11.7536C6.45806 12.173 6.24457 13.071 6.69948 13.7593L9.30052 12.2407ZM6.69948 13.7593L10.1995 19.0556L12.8005 17.5369L9.30052 12.2407L6.69948 13.7593Z" fill="#0027B0"/>
        <path d="M20.371 12.7828C21.0684 12.3406 21.2439 11.4327 20.7629 10.7551C20.2819 10.0775 19.3265 9.88668 18.629 10.3289L20.371 12.7828ZM11.258 18.5608L20.371 12.7828L18.629 10.3289L9.51604 16.107L11.258 18.5608Z" fill="#0027B0"/>
    </svg>

  );
};

export default TickIcon;


